import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminCheckoutAttempts from "@/pages/admin/AdminCheckoutAttempts";

export const Route = createFileRoute("/admin/checkout-attempts")({
  head: () => pageHead("Admin \u2014 Checkout Attempts \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminCheckoutAttempts,
});
